<template>
  <div class="lottery-and-task">
    <div class="lottery-and-task-title"></div>
    <div class="lottery-and-task-sub-title">
      <i class="lottery-and-task-sub-title-icon"></i>
      <span
        >參與共創活動獲得積分，抽取<span class="red"
          >限定虛寶與精美實物周邊</span
        >！</span
      >
      <i class="lottery-and-task-sub-title-icon"></i>
    </div>
    <div class="lottery-and-task-content">
      <Lottery />
      <Task />
    </div>
  </div>
</template>

<script setup>
import Lottery from "./Lottery.vue";
import Task from "./Task.vue";
</script>

<style scoped lang="less"></style>
